// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 897 ? "sentry" : chunkId) + ".legacy." + {"897":"faf5f0eac6d6db9f70bb","945":"4ecf04b7928ec8119957"}[chunkId] + ".js";
};